<div [innerHTML]="config.data"></div>
